const config = {
  title: '指标查看',
  id: '5',
  list: [
      {
          title: '什么是账号安全等级，每个等级代表什么意思?',
          id: '1',
          strongId: 'h1',
          content: `1、安全账号：该账号是一个清白、安全的账号，这类账号到店铺来购买不会存在被监控的风险，可以放心。类似于普通清白的公民。<br/>
2、比较安全账号：该账号可能存在一定问题，有一点小问题但不是原则性大问题，如果实在没有安全账号可用，也可以考虑用，不过一定不能用太多。类似于这个人曾经被告进入过公安局或者在拘留所被关过。<br/>
3、有一定风险账号：该账号通过快现形分析肯定存在问题，有着较大的被纠察到的风险，在做产品推广时尽量不用。类似于这个人曾经进过拘留所关过或者判过3年以下缓刑。<br/>
4、危险账号：该账号通过快现形分析得出已经是危险账号了，除非你完全找不到合适的资源，建议不要轻易用这样的账号。类似于这个人犯过罪进过牢房，被判刑过。<br/>
5、极度危险账号：该账号通过快现形分析得出已经是极度危险账号了，除非你完全不担心出问题，否则绝对不能用这样的账号。类似于该人杀过人、在司法系统已经完全拉黑。一旦某地要打击坏人、抓坏人，肯定先会调出拉黑的人、被判过刑的人，跟他们匹配；再查判过缓刑的人，最后再查曾经有过拘留或者进公安局录过笔录的人。由于普通人的数据量太大了，基本上不会查到普通人身上，这就是普通人偶尔做一些非正常行为，也很难抓到的原因。`,
      },
      {
          title: '什么是快现形黑名单，黑名单怎么来的？',
          id: '2',
          strongId: 'h2',
          content: `当账号被在快现形或者相关地方明确举报过，就会被收录进快现形的黑名单中。<br/>
黑名单账号类型包括买家黑名单账号、卖家黑名单账号，以及中介黑名单等相关所有被举报过的账号。<br/>
买家账号包括：买家Profile ID、买家名字、邮箱、Facebook账号、微信号、QQ号、Tiktok号、Twitter号、Instagram、Whatapp，以及其他信息等。<br/>
卖家账号包括：店铺名字、ID、品牌、公司名字、姓名、电话、微信、QQ、邮箱、以及其他信息等。<br/>
中介信息包括：微信号、QQ号、电话号码、支付宝账号、邮箱、Facebook，以及其他信息等。`,
      },
      {
          title: '怎么通过被查次数判断账号安全？',
          id: '3',
          strongId: 'h3',
          content: `被查次数是指该买家账号之前在快现形上被查询的次数，被查次数越多风险就越大。<br/>
原则上被查次数显示为0或者1，可以说是相对正常；如果超过1次，或多或少有一定的风险。<br/>
如果该账号被查超过5次，就可能是极度危险了，并且在快现形上线前该账号可能也被用了很多次了。<br/>`,
      },
      {
          title: '为什么至少被平台认定的违规次数指标非常重要？',
          id: '4',
          strongId: 'h4',
          content: `此项指标是指卖家由于违规行为被电商平台处罚后，卖家要向电商平台申诉，卖家必须向电商平台一一说明违规的原因、以及哪些买家账号是卖家曾经用过的，而这些买家账号就会被电商平台全部收集起来。<br/>
如果一个买家账号被1个卖家在申诉时向电商平台提交过1次，快现形则将该买家账号定义成被平台认定的违规次数为1次；<br/>
如果一个买家账号被2个卖家在申诉时向电商平台提交过2次，快现形则将该买家账号定义成被平台认定的违规次数为2次；<br/>
而快现形此数据来源于我们美国技术团队原有的数据，并且每天实时监测几百万畅销ASIN是否可售状态，以及ASIN恢复可售/或者长期不可售后对应的链接有无掉评价，并针对掉评价的对应买家账户进行大数据分析，并与原始数据进行对比、分析测算得出；<br/>
实际上该账号被电商平台认定的违规次数只会高于快现形展示的数据，因此快现形将该数据表述为至少被平台认定的违规次数。`,
      },
      {
          title: '买家账号怎么才能获得Vine标？',
          id: '5',
          strongId: 'h5',
          content: `Amazon Vine计划是亚马逊向品牌卖家推出的专属评论计划，它是卖家新品快速获得高质量评论的一条捷径。<br/>
加入该计划的成员，被称为Amazon Vine评论者（也称为Vine Voice, 即Vine发言人）负责免费使用亚马逊卖家提供的产品并为这些商品发表真实的买家评论。<br/>
参加Vine计划的卖家可以免费提供商品给Vine发言人，作为交换，卖家可以获得Vine发言人的评论。<br/>
如果商品能够真正满足Vine发言人的需求，从而获得正面的Vine评论（每个商品最多可获得30个Vine评论），并且每条评论都会有 “Vine Customer Review of Free Product”标记，这将极大地促进商品的排名和转化率。
<p><span style="padding-right:4px;">如图</span><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211025/uf5500.png" style="height:347px; width:389px"></p>`,
      },
      {
          title: '一般什么样的情况下买家会隐藏Profile？',
          id: '6',
          strongId: 'h6',
          content: `99.7%的买家正常展示，分享其评价界面，只有极少数买家会隐藏自己的公共Profile ID，比如很多自养号就会隐藏，惯用刷手也会隐藏，所以隐藏了Profile ID的账号是存在风险的。`,
      },
      {
          title: '为什么快现形上看到的helpful votes，会和买家Profile页面上实际看到helpful votes的数字不一样？',
          id: '7',
          strongId: 'h7',
          content: `我们数据是周期性更新，分为每天、每周两类，可能存在最近几天新的数据没有统计进来，所以导致数据有差异，但是不影响我们对该用户账号安全性的分析。<br/>
账号在电商平台中的安全等级不会由于该账号最近一个月的行为而突然调高，如果该账号原来都是安全账号，哪怕最近一个月非常异常，原则上也不会出问题，因此快现形给出的账号检测结果足够判断该账号是否安全了。<br/>
另外针对数据与实际显示有差异，我们也会在24小时后给您更新的买家账号报告，再次查询也不会重新扣费！`,
      },
      {
          title: '为什么快现形显示的账号排名与买家页面显示不同？',
          id: '8',
          strongId: 'h8',
          content: `买家账号排名受点赞、评价、购买量以及其他买家的排名变化等等因素影响，所以账户排名变化非常快。<br/>
而我们数据是周期性更新，分为每天、每周两类，所以导致数据可能有一定差异，如果排名变化非常大，则说明买家自己肯定发生了一定行为；如果买家排名变化不大，或者只是稍微超出范畴，属于正常浮动范围。<br/>
另外针对数据与实际显示有差异，我们也会在24小时后给您更新的买家账号报告，再次查询也不会重新扣费！`,
      },
      {
          title: '非认证购买比例怎么参考解读？',
          id: '9',
          strongId: 'h9',
          content: `该买家留下的评论中非认证购买的留评数/总留评数，也就是买家直接评价数占总共留评数的比例，比例越高，账号越危险。`,
      },
      {
          title: '为什么快现形显示的差评数和买家页面上看到的不一致？',
          id: '10',
          strongId: 'h10',
          content: `快现形将1、2、3颗星的评价统称为差评，4、5颗星的评价为好评！<br/>
给差评数越多，代表买家更习惯性给产品的差评越多，对于测评来说，给差评的风险更高！<br/>
如果发现买家页面看到的差评数与快现形不一致，只有两种情况：第一该买家自己把产品删掉了；第二该买家的差评被电商平台删掉了，快现形给出的每个数据都是准确且有记录的，大家可以充分信任。<br/>
另外针对数据与实际显示有差异，我们也会在24小时后给您更新的买家账号报告，再次查询也不会重新扣费！`,
      },
      {
          title: '什么是买家活跃指数？',
          id: '11',
          strongId: 'h11',
          content: `买家活跃指数是买家在电商平台的活跃程度的数字体现；该活跃指数是快现形根据买家在电商平台在线状态、在线时长、购买量、评价情况以及参与讨论等因素影响，正常情况下最不活跃买家或者太活跃买家都不能算是优质的账户！TOP10000买家账户除外！`,
      },
  ]
}

export default config
